<template>
    <div class="column_start_start w-full py-2 px-[6%] bg-[#FAFAFA] mt-5" v-if="isDelivery || isPickUp">
        <div class="row_center_between w-full pt-3">
            <text class="title">取餐資訊</text>
        </div>
        <deliveryInfo v-if="isDelivery" />
        <pickUpInfo v-if="isPickUp" />
    </div>
</template>

<script>
import deliveryInfo from "@/components/store/deliveryInfo.vue"
import pickUpInfo from "@/components/store/pickUpInfo.vue"

export default {
    name: 'ConsumptionModeDetails',
    components: {
        deliveryInfo: deliveryInfo,
        pickUpInfo: pickUpInfo
    },
    props: {
        // 消費模式：'dineIn', 'takeOut', 'pickUp', 'delivery'
        consumptionMethod: {
            type: String,
            required: true,
            validator: (value) => ['dineIn', 'takeOut', 'pickUp', 'delivery'].includes(value)
        }
    },
    computed: {
        // 是否為店家外送模式
        isDelivery() {
            return this.consumptionMethod === 'delivery'
        },
        // 是否為預約自取模式
        isPickUp() {
            return this.consumptionMethod === 'pickUp'
        }
    }
}
</script>

<style lang="scss" scoped>
// 繼承父組件的樣式，無需額外樣式
</style>